import { render, staticRenderFns } from "./IframeLayout.vue?vue&type=template&id=47db6eba&scoped=true&"
import script from "./IframeLayout.vue?vue&type=script&lang=js&"
export * from "./IframeLayout.vue?vue&type=script&lang=js&"
import style0 from "./IframeLayout.vue?vue&type=style&index=0&id=47db6eba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47db6eba",
  null
  
)

export default component.exports